import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import helpCsvParser from '../../utils/help-csv-parser';
import ActiveApplicationContext from '../../contexts/active-application-context';
import HelpContext from '../../contexts/help-context';
import LanguageContext from '../../contexts/language-context';

export default function HelpProvider(props) {
  const {children} = props;
  const {application} = React.useContext(ActiveApplicationContext);
  const {language} = React.useContext(LanguageContext);
  const [helpTopics, setHelpTopics] = React.useState({});

  const loadHelpTopics = React.useCallback(async (appId, lang) => {
    const url = `${process.env.PUBLIC_URL}/${appId}/locales/${lang}/help.csv`;
    try {
      const loadedTopics = (await axios.get(url)).data;
      setHelpTopics(await helpCsvParser(loadedTopics));
    } catch (ex) {
      console.error(`Unable to load help topics from ${url}.`, ex);
      setHelpTopics({});
    }
  });

  React.useEffect(() => {
    if (application?.id && language) {
      loadHelpTopics(application.id, language);
    }
  }, [application, language]);

  return <HelpContext.Provider value={helpTopics}>{children}</HelpContext.Provider>;
}

HelpProvider.propTypes = {
  children: PropTypes.node,
};
